import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/easi-animations.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Preview branch — visiting any URL with `?preview=folders` skips the whole
// auth + router + provider stack and mounts a self-contained render harness
// for the five-folder patient profile layout. Both branches are dynamically
// imported so the auth module's top-level side effects (token-refresh check
// that redirects to /login) only run when the production path is selected.
// Reachable only via the explicit query parameter, so production users
// cannot land here.
const previewParam = new URLSearchParams(window.location.search).get('preview');
if (previewParam === 'folders') {
  import('./preview/PatientFoldersPreview').then(({ default: PatientFoldersPreview }) => {
    root.render(
      <React.StrictMode>
        <PatientFoldersPreview />
      </React.StrictMode>,
    );
  });
} else if (previewParam === 'patient-detail') {
  import('./preview/PatientDetailPreview').then(({ default: PatientDetailPreview }) => {
    root.render(
      <React.StrictMode>
        <PatientDetailPreview />
      </React.StrictMode>,
    );
  });
} else {
  // Lazy-import the entire production tree so preview mode does NOT pay
  // the cost of (or trigger side effects from) any of these modules.
  Promise.all([
    import('@mui/material'),
    import('react-router-dom'),
    import('./App'),
    import('./theme'),
    import('./hooks/useAuth'),
    import('./contexts/SubscriptionContext'),
    import('./contexts/MySLPConversationContext'),
    import('./components/SecurityWrapper'),
  ]).then(([
    { ThemeProvider, CssBaseline },
    { BrowserRouter },
    { default: App },
    { default: theme },
    { AuthProvider },
    { SubscriptionProvider },
    { MySLPConversationProvider },
    { SecurityWrapper },
  ]) => {
    root.render(
      <React.StrictMode>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <BrowserRouter>
            <AuthProvider>
              <SubscriptionProvider>
                <SecurityWrapper>
                  <MySLPConversationProvider>
                    <App />
                  </MySLPConversationProvider>
                </SecurityWrapper>
              </SubscriptionProvider>
            </AuthProvider>
          </BrowserRouter>
        </ThemeProvider>
      </React.StrictMode>,
    );
  });
}
